module.exports = __webpack_public_path__ + "static/media/keyboard.cd911e21.svg";